import React from 'react';
import { Award, MapPin, Sprout } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-20 bg-stone-50" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-20">
            Who We Are
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto rounded-full" data-id="element-21"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-22">
          <div className="relative" data-id="element-23">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-green-100 rounded-tl-3xl -z-10" data-id="element-24"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-amber-100 rounded-br-3xl -z-10" data-id="element-25"></div>
            <img src="https://images.unsplash.com/photo-1595411425732-e69c1c201d8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Historical farm photo" className="rounded-xl shadow-xl w-full h-[500px] object-cover" data-id="element-26" />
            <div className="absolute bottom-8 left-8 bg-white/95 backdrop-blur p-4 rounded-lg shadow-lg max-w-xs border-l-4 border-green-600" data-id="element-27">
              <p className="text-green-900 font-bold text-lg" data-id="element-28">Did You Know?</p>
              <p className="text-gray-600 text-sm mt-1" data-id="element-29">
                In 1970, our founding father won multiple agriculture awards for
                excellence in farming.
              </p>
            </div>
          </div>

          <div className="space-y-8" data-id="element-30">
            <div data-id="element-31">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-32">
                Rooted in Nyandarua
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg" data-id="element-33">
                We are located in the fertile highlands of Nyandarua County,
                Kenya. Our story begins with our father, Jeremiah, who purchased
                this land shortly after Kenya's independence following the
                departure of white settlers.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-34">
              <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100 hover:shadow-md transition-shadow" data-id="element-35">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-36">
                  <Sprout className="h-6 w-6 text-green-700" data-id="element-37" />
                </div>
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-38">
                  Fertile Heritage
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-39">
                  Part of the shamba was originally an animal shed, blessing us
                  with incredibly fertile soil that sustains our crops today.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100 hover:shadow-md transition-shadow" data-id="element-40">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4" data-id="element-41">
                  <Award className="h-6 w-6 text-amber-700" data-id="element-42" />
                </div>
                <h4 className="font-bold text-gray-900 mb-2" data-id="element-43">
                  Legacy of Excellence
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-44">
                  Building on the foundation of award-winning agricultural
                  practices established in the 1970s.
                </p>
              </div>
            </div>

            <div className="bg-green-900 text-white p-6 rounded-xl" data-id="element-45">
              <h4 className="font-bold text-lg mb-2 flex items-center" data-id="element-46">
                <MapPin className="h-5 w-5 mr-2 text-green-300" data-id="element-47" />
                Our Location
              </h4>
              <p className="text-green-100" data-id="element-48">
                Nestled in the heart of Nyandarua, taking advantage of the cool
                climate and rich volcanic soils perfect for dairy farming.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}